import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
// import { EllipsisModule } from '@thisissoon/angular-ellipsis';
import { EllipsisModule } from 'ngx-ellipsis';
import { FileUploadModule } from 'ng2-file-upload';
// import { NgxEchartsModule } from 'ngx-echarts';

// import { TWADialogsModule, TWAConfirmDialogComponent, TWAPromptDialogComponent } from 'twa-md2-dialogs';
// import { TWAMd2NotificationsModule } from 'twa-md2-notifications';
// import { TWADialogsService } from './_services/twa-dialogs.service';
import { TWAMd2NotificationsModule } from './_components/twa-md2-notifications/twa-md2-notifications.module';
import { TWAMd2DynformsModule } from './_components/twa-md2-dynforms/twa-md2-dynforms.module';
import { TWADialogsService } from './_services/twa-dialogs.service';

import { LoaderComponent } from './_services/loader/loader.component';
import { LoaderService } from './_services/loader/loader.service';
import { DocsService } from './_services/docs.service';
import { DynamicFormGroupsModule } from './_components/dynamic-form-groups.module';
import { AiAssistantModule } from './_components/ai-assistant/ai-assistant.module';
import { TWAFilterEditorModule } from './_components/twa-md2-filter-editor/twa-md2-filter-editor.module';

// import { DialogsModule } from './_services/dialogs/dialogs.module';
import { MqIfDirectiveModule } from './_directives/mqif.directive';

import { AuthenticationService } from './_services/authentication.service';
import { AnimalsService } from './_services/animals.service';
import { WorksService } from './_services/works.service';
import { WorksPendingService } from './_services/works-pending.service';
import { HistLactacionesService } from './_services/hist-lactaciones.service';
import { LibrosService } from './_services/libros.service';
import { DashboardService } from './_services/dashboard.service';
import { CEAService } from './_services/cea.service';
import { AuthGuard } from './_guards/auth.guard';
import { ServerConn, serverConnCreator } from './serverConn.service';
import { WindowRef } from './_services/windowref.service';

import { TablePartesDialogModule } from './_components/table-partes-dialog/table-partes-dialog.module';
// import { ShowDocDialogModule } from './docs/docs-dialogs/show/show-doc-dialog.module';
// import { fichaAnimalDialog } from './_components/ficha-animal/ficha-animal-dialog.component';
import { FichaAnimalDialogModule } from './_components/ficha-animal/ficha-animal-dialog.module';
// import { WindowRef } from './_components/windowref.component';

import { MirrorDatePipeModule } from './_pipes/mirror-date.pipe';
import { BoloPipeModule } from './_pipes/bolo.pipe';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MyDateAdapter } from './_config/my-date-adapter.config';
// import { MainComponent } from './main/main.component';
// import { LoginComponent } from './login/login.component';
// import { LoginRecoverComponent } from './login/login-recover.component';
// import { AnimalsComponent } from './animals/animals.component';
// import { WorksPendingComponent } from './works-pending/works-pending.component';
// import { HistLactacionesComponent } from './hist-lactaciones/hist-lactaciones.component';
// import { InformesComponent } from './informes/informes.component';
// import { PartesComponent } from './partes/partes.component';
// import { LibrosComponent } from './libros/libros.component';
// import { ImportsComponent } from './imports/imports.component';

// import { CardLotesModule } from './_components/widgets/card-lotes/card-lotes.module';
// import { CardChartLactacionesModule } from './_components/widgets/card-chart-lactaciones/card-chart-lactaciones.module';
// import { CardChartPartosMesesModule } from './_components/widgets/card-chart-partos-meses/card-chart-partos-meses.module';
// import { CardChartAnimalsModule } from './_components/widgets/card-chart-animals/card-chart-animals.module';
// import { CardChartAnimalsAgeModule } from './_components/widgets/card-chart-animals-age/card-chart-animals-age.module';
// import { CardChartAnimalesEstadosModule } from './_components/widgets/card-chart-animales-estados/card-chart-animales-estados.module';
// import { CardChartAltasBajasModule } from './_components/widgets/card-chart-altas-bajas/card-chart-altas-bajas.module';

import { GtagModule } from './_directives/gtag/gtag.module';
import { GtagConfig } from './_directives/gtag/gtag-factory';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MyCustomPaginatorIntl } from './_providers/mat-paginator-intl-es';

export let GtagBaseConfig: GtagConfig = {
  targetId: ''
};

@NgModule({ declarations: [
        AppComponent,
        // TWAConfirmDialogComponent,
        // TWAPromptDialogComponent,
        // MainComponent,
        // LoginComponent,
        // LoginRecoverComponent,
        // AnimalsComponent,
        // WorksPendingComponent,
        // HistLactacionesComponent,
        // TablePartesDialog,
        // fichaAnimalDialog,
        LoaderComponent,
        // TWAGraphPieV1Component,
        // TWAGraphBarComponent,
        // TWAFilterEditorComponent,
        // MirrorDatePipe,
        // BoloPipe,
        // InformesComponent,
        // PartesComponent,
        // LibrosComponent,
        // ImportsComponent,
        // MqIfDirective,
    ],
    exports: [
        LoaderComponent
    ],
    // entryComponents: [
    //     // TWAConfirmDialogComponent,
    //     // TWAPromptDialogComponent,
    //     // fichaAnimalDialog,
    //     // TablePartesDialog
    // ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatMenuModule,
        MatCardModule,
        MatToolbarModule,
        MatInputModule,
        MatCheckboxModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatNativeDateModule,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatSidenavModule,
        MatListModule,
        MatMenuModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatDialogModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatSnackBarModule,
        FileUploadModule,
        // NgxEchartsModule,
        TWAFilterEditorModule,
        MirrorDatePipeModule,
        BoloPipeModule,
        MqIfDirectiveModule,
        // TWADialogsModule,
        TWAMd2NotificationsModule,
        TWAMd2DynformsModule,
        EllipsisModule,
        DynamicFormGroupsModule,
        AiAssistantModule,
        FichaAnimalDialogModule,
        TablePartesDialogModule,
        // ShowDocDialogModule,
        // DialogsModule,
        // CardLotesModule,
        // CardChartLactacionesModule,
        // CardChartPartosMesesModule,
        // CardChartAnimalsModule,
        // CardChartAnimalsAgeModule,
        // CardChartAnimalesEstadosModule,
        // CardChartAltasBajasModule,
        GtagModule.init(GtagBaseConfig),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        // TWAConfirmDialogComponent,
        // TWAPromptDialogComponent,
        Title,
        DocsService,
        LoaderService,
        DashboardService,
        AnimalsService,
        WorksService,
        WorksPendingService,
        HistLactacionesService,
        LibrosService,
        CEAService,
        AuthGuard,
        AuthenticationService,
        WindowRef,
        TWADialogsService,
        // serverConn,
        {
          provide: MatPaginatorIntl,
          useClass: MyCustomPaginatorIntl
        },
        {
            provide: ServerConn,
            useFactory: serverConnCreator,
            deps: [
                HttpClient,
                Router,
                LoaderService,
                WindowRef
            ]
        },
        WindowRef,
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'es-ES'
        },
        {
            provide: DateAdapter,
            useClass: MyDateAdapter
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
